import React from 'react';
import * as ReactDOM from 'react-dom';

import { PageLayout } from '../../types';

type Props = {
    layout: PageLayout,
}

const container = document.createElement('div');

class Layout extends React.Component<Props> {
    headerEl: HTMLElement;

    bodyEl: HTMLElement;

    footerEl: HTMLElement;

    rootEl: HTMLElement;

    styleEl: HTMLElement;

    constructor(props: Props) {
        super(props);
        /* eslint-disable prefer-destructuring */
        this.headerEl = document.getElementsByTagName('header')[0];
        this.bodyEl = document.getElementsByTagName('body')[0];
        this.footerEl = document.getElementsByTagName('footer')[0];
        this.rootEl = document.getElementById('root')!;
        /* eslint-enable prefer-destructuring */

        this.styleEl = document.createElement('style');
    }

    componentDidMount() {
        const { layout } = this.props;

        this.headerEl.style.color = layout.headerColor.fontColor;
        this.headerEl.style.borderColor = layout.headerColor.bgColor;

        if (layout.footerColor) {
            this.footerEl.style.backgroundColor = layout.footerColor.bgColor;
            this.footerEl.style.color = layout.footerColor.fontColor;
        }

        this.bodyEl.style.backgroundColor = layout.bodyColor.bgColor;
        this.rootEl.style.color = layout.bodyColor.fontColor;

        this.styleEl.innerHTML = `header:after { background-image: URL("${layout.headerWaveUrl}"); }
        footer:before { background-image: URL("${layout.footerWaveUrl}"); }`;
        document.head.appendChild(this.styleEl);
    }

    componentWillUnmount() {
        this.headerEl.style.backgroundColor = '';
        this.headerEl.style.color = '';
        this.headerEl.style.borderColor = '';

        this.bodyEl.style.backgroundColor = '';
        this.rootEl.style.color = '';

        this.footerEl.style.backgroundColor = '';
        this.footerEl.style.color = '';

        document.head.removeChild(this.styleEl);
    }

    render() {
        return ReactDOM.createPortal(
            (<div />),
            container!,
        );
    }
}

export default Layout;
